import { Component } from '@angular/core';

@Component({
  selector: 'irembogov-error-404',
  templateUrl: './error-404.component.html',
})
export class Error404MissingResourceComponent {}
